import axios, { AxiosPromise } from 'axios'
import { EmitirPrescricaoDigitalInput } from 'hooks/assinatura-digital/model-assinaturaDigitalPopup'
import { ImpressaoMedicamentosInput } from 'view/atendimentos/detail/soap/plano/prescricao-medicamento/modal/impressao/ImpressaoMedicamentosInput'
import { PrescricaoDigitalInvalidarInput } from 'view/atendimentos/detail/soap/plano/prescricao-medicamento/modal/prescricao-digital/model-prescricaoDigital'

export class PrescricaoDigital {
  gerarPrescricaoDigital(input: ImpressaoMedicamentosInput): AxiosPromise {
    return axios.post('/api/atendimento/gerarPrescricaoDigital', input, { responseType: 'text' })
  }

  emitirPrescricaoDigital(input: EmitirPrescricaoDigitalInput): AxiosPromise {
    return axios.post('/api/atendimento/emitirPrescricaoDigital', input, { responseType: 'text' })
  }

  downloadPrescricaoDigital(codigoAcessoPrescricao: string): AxiosPromise {
    return axios.post(
      `/api/atendimento/downloadPrescricaoDigital`,
      { codigoPrescricaoDigital: codigoAcessoPrescricao },
      { responseType: 'blob' }
    )
  }

  invalidarPrescricaoDigital(input: PrescricaoDigitalInvalidarInput): AxiosPromise {
    return axios.post(`/api/atendimento/invalidarPrescricaoDigital`, {
      atendimentoId: input.atendimentoId,
      codigoPrescricaoDigital: input.codigoPrescricao,
    })
  }
}
